/**
 * Centralized route definitions for the LLTS application.
 * These routes are defined as fragments without leading slashes or lltsBranchId prefixes.
 * The branch-aware navigation utilities will automatically handle the lltsBranchId parameter.
 */

/**
 * Route fragments (without leading slash or lltsBranchId)
 * These should be used with the branch-aware navigation utilities.
 */
export const ROUTES = {
  // Core application routes
  HOME: "/",
  DASHBOARD: "DASHBOARD",
  REPORTS: "reports",
  SIGN_UP: "signUp",
  PBI_REPORTS: "pbiReports",

  // Project management routes
  CREATE_PROJECT: "createProject",

  // Coupa-related routes
  COUPA: "coupa",
  COUPA_CREATE_QUOTE: "/coupa/createQuote",

  // Machine translation routes
  MACHINE_TRANSLATION: "machineTranslation",
  MACHINE_TRANSLATION_TEXT: "machineTranslation/textTranslation",
  MACHINE_TRANSLATION_FILE: "machineTranslation/fileTranslation",
  MACHINE_TRANSLATION_MEDIA: "machineTranslation/mediaTranslation",
  MACHINE_TRANSLATION_AI_TOOLBOX: "machineTranslation/aiToolbox"
} as const;
